import { useEffect, useState } from 'react';

/**
 * Valeur retardée, pour ne déclencher une requête qu'une fois la frappe finie.
 *
 * Les écrans dont la recherche est faite côté serveur mettaient le terme
 * directement dans les dépendances du chargement: chaque lettre relançait un
 * appel, donc un état « chargement », donc le remplacement de la page par un
 * squelette — et le champ de saisie disparaissait sous les doigts. Le retard
 * n'est pas un confort de performance ici, c'est ce qui rend le champ
 * utilisable.
 */
export function useDebouncedValue(value, delayMs = 350) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}

export default useDebouncedValue;
